import useEffectOnce from 'react-use/lib/useEffectOnce';

import {
  type Filter,
  type FilterDefinition,
  type FilterEditorComponentProps,
  createFilter,
} from './provider';

const ToggleFilterEditor = ({
  onValueChange,
  onClose,
}: FilterEditorComponentProps<boolean>) => {
  useEffectOnce(() => {
    onValueChange(true);
    onClose();
  });

  return null;
};

export const createToggleFilter = (
  config: Omit<Filter<boolean>, 'editor' | 'interaction'>,
): FilterDefinition =>
  createFilter({
    ...config,
    interaction: 'toggle',
    editor: ToggleFilterEditor,
  });
